import cx from 'classnames';
import { Dispatch, SetStateAction } from 'react';

import { useTrackEventAmplitude } from '../../../../../../core/Tracking/Amplitude/Amplitude';
import { IconArrowLeft } from '../../../../../../design-system/components/icons/ArrowLeft';
import { IconCross } from '../../../../../../design-system/components/icons/Cross';
import { NavItemButton } from '../../../../../../design-system/components/nav/nav-item/NavItem';
import { PrimaryNavValue } from '../../../types';

import style from './MobileSubNav.module.css';

type Props = {
    onPrevious?: () => void;
    className?: string;
    showPreviousButton: boolean;
    setNavValue: Dispatch<SetStateAction<PrimaryNavValue>>;
};

export function MobileSubNav({ onPrevious, className, showPreviousButton, setNavValue }: Props) {
    const { trackEvent } = useTrackEventAmplitude();
    return (
        <div className={cx(style.mobileSubNav, className)}>
            {showPreviousButton ? (
                <NavItemButton iconOnly iconLeading={<IconArrowLeft />} onClick={onPrevious} />
            ) : null}
            <NavItemButton
                className={style.closeButton}
                iconOnly
                iconLeading={<IconCross />}
                onClick={() => {
                    setNavValue(null);
                    trackEvent((ampli, defaultProperties) => {
                        ampli.primaryNavMenuClosed({
                            ...defaultProperties,
                            block: 'primary_nav',
                        });
                    });
                }}
            />
        </div>
    );
}
